module.exports = __webpack_public_path__ + "static/info-icon-2ecb118f4dcbd6ccff803ea510eafb1b.svg";